import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { faireBaseUrl } from '@faire/web--source/common/routes/faireBaseUrl';
import { compile } from 'path-to-regexp';
import qs from 'query-string';
export var QueryParameters;
(function (QueryParameters) {
  QueryParameters.build = function (partial) {
    return partial;
  };
  /**
   * Parse the given raw query string or partially-parsed react-router-dom queryParams object.
   */
  function parse() {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var rawParsed = typeof search === 'string' ? qs.parse(search) : search !== null && search !== void 0 ? search : {};
    var parsed = _objectSpread({}, rawParsed);
    return parsed;
  }
  QueryParameters.parse = parse;
})(QueryParameters || (QueryParameters = {}));
/**
 * Generated from Jersey path "/brand-portal/my-shop/settings"
 *
 * Product Area: BRAND_SHOP_SETTINGS
 */
export var route = '/brand-portal/my-shop/settings';
export var props = {
  path: route,
  templatedPath: '/brand-portal/my-shop/settings',
  productArea: 'BRAND_SHOP_SETTINGS',
  pod: 'FAIRE_POD_BRAND_GROWTH',
  pillar: 'FAIRE_PILLAR_BRAND'
};
export var toPath = compile(route, {
  encode: encodeURIComponent
});
export function path(queryParams) {
  var compiledPath = toPath({});
  var queryString = queryParams ? qs.stringify(queryParams) : '';
  return "".concat(compiledPath).concat(queryString ? "?".concat(queryString) : '');
}
/**
 * Build a full URL of the route (including the base faire URL).
 */
export var url = function url(queryParams) {
  return faireBaseUrl(3001) + path(queryParams);
};
export default path;